import { atom } from 'recoil';
import { IShopOrder } from '../../features/Orders/types';
import { IOrderItem } from '../types/dbRecords';

export const salesOrderEpochAtom = atom<number>({
  key: 'salesOrderEpochAtom',
  default: new Date().getTime(),
});

export const salesOrderStartDateAtom = atom<Date>({
  key: 'salesOrderStartDateAtom',
  default: new Date(2021, 0, 1),
});

export const salesOrderEndDateAtom = atom<Date>({
  key: 'salesOrderEndDateAtom',
  default: new Date(2021, 11, 31),
});

export const salesOrdersAtom = atom<IShopOrder[]>({
  key: 'salesOrdersAtom',
  default: [],
});

export const salesOrderItemsAtom = atom<IOrderItem[]>({
  key: 'salesOrderItemsAtom',
  default: [],
});

export const salesOrderCopyItemAtom = atom<any>({
  key: 'salesOrderCopyItemAtom',
  default: {},
});

export const salesOrderPasteEnabledAtom = atom<boolean>({
  key: 'salesOrderPasteEnabledAtom',
  default: false,
});

export const showAddSalesOverlayAtom = atom<boolean>({
  key: 'addSalesOverlay',
  default: false,
});

export const currentSalesOrderAtom = atom<string>({
  key: 'currentSalesOrderAtom',
  default: '',
});

export const salesOrderEditedAtom = atom<boolean>({
  key: 'salesOrderEditedAtom',
  default: false,
});

/**
 * True when order line items changed this session and the order description
 * may be stale (qty/SKU/notes/price/add/remove). Cleared when the user edits
 * the description or acknowledges the reminder modal.
 */
export const orderItemsDirtyForDescriptionAtom = atom<boolean>({
  key: 'orderItemsDirtyForDescriptionAtom',
  default: false,
});

export const showSODownloadAtom = atom<boolean>({
  key: 'showSODownloadAtom',
  default: false,
});
